import { request } from '@/utils/request.js';

/**
 * 二筛评估功能 Mixin
 * 通过 /api/send-message（isAssessment=true → 后端传 intent=assessment）进行心理评估
 */
export default {
    data() {
        return {
            isAssessmentMode: false, // 是否处于评估模式
            isAssessmentWaiting: false, // 是否正在等待 Dify 的评估问题
        };
    },

    methods: {
        // 启动评估模式
        async assessmentStartMode() {
            this.isAssessmentMode = true;
            this.isAssessmentWaiting = true;

            // 发送初始消息触发评估第一问
            this.messages.push({
                type: 'user',
                content: '进行心理评估',
            });

            await this.assessmentSendToDify('进行心理评估');
        },

        // 发送消息给 FastGPT（评估模式专用，使用阻塞式请求）
        async assessmentSendToDify(message) {
            const msgIndex = this.messages.length;
            this.messages.push({ type: 'thinking' });
            this.chatScrollToBottom();

            try {
                const res = await request({
                    url: '/api/send-message',
                    method: 'POST',
                    data: {
                        message: message,
                        conversationId: this.chatConversationId,
                        isAssessment: true,
                    },
                });

                const data = res.data;
                if (data.code === 200) {
                    const reply = data.data.difyReply || '';
                    const audioUrl = data.data.audioUrl;

                    // 用打字机效果展示文字
                    this.chatStartTypewriter(reply, msgIndex, () => {
                        // 打字机结束后不做额外处理
                    });

                    // 更新会话ID
                    if (data.data.conversationId) {
                        this.chatConversationId = data.data.conversationId;
                    }

                    this.isAssessmentWaiting = false;

                    // 播放语音
                    if (audioUrl) {
                        this.audioPlay(audioUrl);
                    }

                    // 检测到评估结束标记：延迟跳转报告页生成并展示评估报告
                    if (data.data.isReport) {
                        setTimeout(() => {
                            this.assessmentFinish();
                        }, 1500);
                    }
                } else {
                    this.$set(this.messages, msgIndex, {
                        type: 'bot',
                        content: data.message || '抱歉，获取问题失败，请重试~',
                    });
                    this.isAssessmentWaiting = false;
                    this.$toast(data.message || '获取失败');
                }
            } catch (err) {
                console.error('评估请求失败:', err);
                // 401 踢下线场景：request.js 已统一弹提示并跳登录页，此处静默避免「网络错误」盖掉提示
                if (err.isAuthError) return;
                this.$set(this.messages, msgIndex, {
                    type: 'bot',
                    content: '网络错误，请重试~',
                });
                this.isAssessmentWaiting = false;
                this.$toast('网络错误，请重试');
            }
        },

        // 提交评估答案
        async assessmentSubmitAnswer(answer) {
            if (!this.isAssessmentMode) return;

            // 后端以 intent=assessment 传给 FastGPT 分流评估分支，答案原文发送即可
            await this.assessmentSendToDify(answer);
        },

        // 完成评估：结束会话并跳转报告页等待生成（与普通聊天报告一致的展示方式）
        async assessmentFinish() {
            // 记录会话ID（跳转报告页生成评估报告需要）
            const cid = this.chatConversationId;

            this.isAssessmentMode = false;
            this.isAssessmentWaiting = false;

            // 停止音频和打字机效果
            this.audioStop();
            this.chatStopTypewriter();
            if (this.chatThinkingTimer) {
                clearTimeout(this.chatThinkingTimer);
                clearInterval(this.chatThinkingTimer);
                this.chatThinkingTimer = null;
            }

            // 结束当前会话（写入历史记录）
            if (cid) {
                try {
                    await request({
                        url: '/api/end-conversation',
                        method: 'POST',
                        data: { conversationId: cid },
                    });
                } catch (e) {
                    console.error('标记会话结束失败:', e);
                }
            }

            // 清空会话ID和消息列表
            this.chatConversationId = '';
            this.messages = [];

            // 跳转报告页等待评估报告生成（type=assessment 标记评估报告）
            if (cid) {
                this.$router.push(
                    `/report?conversationId=${cid}&type=assessment`
                );
            } else {
                this.chatShowDefaultWelcome();
            }
        },
    },
};
